import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

// Native form validation accepts phone punctuation, with 7–15 actual digits.
export const APPLICATION_PHONE_PATTERN = '\\+?(?:[\\s\\(\\)\\.\\-]*[0-9]){7,15}[\\s\\(\\)\\.\\-]*';
const phoneShape = new RegExp(`^(?:${APPLICATION_PHONE_PATTERN})$`);

/**
 * Parse national numbers using the selected ISO country, defaulting to the US.
 * For US/Canadian forms, also accept a pasted calling code without a plus sign.
 * Require a recognized calling code and possible national length before formatting.
 */
const parseApplicationPhone = (value, countryCode) => {
  if (!phoneShape.test(value)) {
    return null;
  }
  const phone = parsePhoneNumberFromString(value, { defaultCountry: countryCode || undefined, extract: false });
  if (phone && phone.isPossible()) {
    return phone;
  }

  const digits = value.replace(/\D/g, '');
  if (['US', 'CA'].includes(countryCode) && !value.trim().startsWith('+')
      && /^[1-9][0-9]{10,12}$/.test(digits)) {
    const international = parsePhoneNumberFromString(`+${digits}`, { extract: false });
    return international && international.isPossible() ? international : null;
  }
  return null;
};

/**
 * Format complete phone numbers on blur. Preserve incomplete or ambiguous input.
 * @param {string} value Phone field value, with optional punctuation or calling code.
 * @param {string|null} countryCode Selected ISO country; null means unknown.
 * @returns {string} International display value, or the original unparsed input.
 */
export const formatApplicationPhone = (value, countryCode = 'US') => {
  const phone = parseApplicationPhone(value, countryCode);
  if (!phone) {
    return value;
  }
  return phone.countryCallingCode === '1' ? `+1 ${phone.formatNational()}` : phone.formatInternational();
};



// WEBPACK FOOTER //
// blocks/quote-calculator/app/phoneNumbers.js